import { css } from 'aphrodite';
import * as React from 'react';
import { styleSheet } from './styles';

export const RenewalSummaryHeader: React.FC = () => {
	return (
		<div className={css(styleSheet.accountsHeader)}>
			<div className={css(styleSheet.accountHeaderName)}>Account</div>
			<div className={css(styleSheet.accountHeaderSmall)}>Renewal</div>
			<div className={css(styleSheet.accountHeaderSmall)}>Period</div>
			<div className={css(styleSheet.accountHeaderSmall, styleSheet.mrrColumn)}>MRR</div>
			<div className={css(styleSheet.accountHeaderLarge)}>CSM</div>
			<div className={css(styleSheet.accountHeaderLarge)}>Probability</div>
			<div className={css(styleSheet.accountHeaderLarge)}>Discount %</div>
			<div className={css(styleSheet.accountHeaderSelect)}>Will Renew Prediction</div>
			<div className={css(styleSheet.accountHeaderSmall)}>Confirmed</div>
		</div>
	);
};
